import React, { useEffect, Suspense, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import WebFont from 'webfontloader';
import { useLDClient } from 'launchdarkly-react-client-sdk';

// PAGEs
import Base from './pages/Base-v2';
import Login from './pages/Login';
import LoginEntraID from './pages/Login_EntraID';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import AdminDash from './pages/AdminDash';
import LeaderDash from './pages/LeaderDash';
import TraineeDash from './pages/TraineeDash';
import Metrics from './pages/Metrics';
import MetricsSettings from './pages/MetricsSettings';
import TrialAccounts from './pages/TrialAccounts';
import UnityApp from './pages/UnityApp';
import Administrator from './pages/Administrator';
import LogEngine from './pages/LogEngine';
import Subscription from './pages/Subscription';
import Subscribe from './pages/Subscribe';
import SubscribeNew from './pages/SubscribeNew';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionUpdateSuccess from './pages/SubscriptionUpdateSuccess';
import SubscriptionRenewSuccess from './pages/SubscriptionRenewSuccess';
import SubscriptionError from './pages/SubscriptionError';

// COMPONENTS
import UserNav from './components/UserNav-v2';
// REDUX
import { 
  setTriedToReload, 
  setPrivacy, 
  setAppVerbosity, 
  setAppReactVerbosity } from './redux/app.slice';
import {
  setUser,
  setName,
  setRole,
  setOrganization,
  setLoginStatus,
  setIdToken
} from "./redux/user.slice"; // eslint-disable-line
import { setToken } from "./redux/token.slice";

// APIs
import { reloadSession } from './apis/user.api';
import { fetchAppVerbosityApi } from './apis/app.api';

if (navigator.appVersion.indexOf('Win') !== -1) {
  // Windows
  document.getElementsByTagName('body')[0].classList.add('win');
} else if (navigator.appVersion.indexOf('Mac') !== -1) {
  // Mac
  document.getElementsByTagName('body')[0].classList.add('mac');
}

function App() {
  const dispatch = useDispatch();
  const [pageReady, setPageReady] = useState(false);
  
  const { triedToReload } = useSelector((state) => state.app, shallowEqual);
  const { currentPage } = useSelector((state) => state.app, shallowEqual);
  const { role } = useSelector((state) => state.user.user, shallowEqual);
  const { loginStatus } = useSelector((state) => state.user, shallowEqual); // eslint-disable-line
  const app = useSelector((state) => state.app); // eslint-disable-line

  const ldClient = useLDClient();
  const userEmail = useSelector((state) => state.user.user?.email);
  useEffect(() => {
    if (!ldClient || !userEmail) return;
    ldClient.identify({
      kind: 'user',
      key: userEmail,
      email: userEmail,
    });
  }, [ldClient, userEmail]);

  // useEffect(() => {
  //   setInterval(async () => {
  //     // Testing cacheBusting
  //     console.log('** BUSTING THE CACHE **')
  //     window.caches.open('my-cache').then(function(cache) {
  //       cache.keys().then(function(keys) {
  //         keys.forEach(function(key) {
  //           cache.delete(key);
  //         });
  //       });
  //       console.log('** CACHE BUSTED **')
  //     });
  //   },  40 * 1000);
  // }, []);

  useEffect(() => {
    // Set pageReady to true after a short delay
    const timer = setTimeout(() => setPageReady(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Poppins', 'Montserrat']
      }
    });
  }, []);

  const reload = async () => {
    setTimeout(async () => {
      // console.log('RELOAD SESSION', triedToReload)
      if (!triedToReload) {
        try {
          reloadSession().then(async (res) => {
            if (res.data.error) {
              app.reactVerbosity >= 2 && console.log('APP RELOAD SESSION ERROR:', res.data.error)
              await window.history.pushState({}, '', '/login');
            } else {
              console.log('APP RELOAD SESSION SUCCESS')
              await dispatch(setTriedToReload(true));
              if (res.data !== '') {
                const user = res.data;
                const idTokenResult = user.accessToken;
                const verbosity = await fetchAppVerbosityApi(idTokenResult);
                console.log('!!! --------------> refresh user, app.verbosity:', user.email, verbosity.data);
                await dispatch(setAppVerbosity(verbosity.data.verbosity));
                await dispatch(setAppReactVerbosity(verbosity.data.reactVerbosity));
                await dispatch(setToken(idTokenResult));
                await dispatch(setIdToken(idTokenResult));
                await dispatch(setUser(JSON.stringify(user)));
                await dispatch(setLoginStatus(user.loggedIn));
                await dispatch(setRole(user.role));
                await dispatch(setName(user.name));
                await dispatch(setOrganization(user.organization));
                if (user && user.organization && Object.keys(user.organization).includes('privacy')) {
                  await dispatch(setPrivacy(user.organization.privacy));
                } else {
                  await dispatch(setPrivacy(0));
                }
                await window.history.pushState({}, '', '/');
              }
            }
            
          });
        } catch (err) {
          // TBD remove log
          // console.log(err)
        }
      } else {
        // console.log("ALREADY TRIED TO RELOAD SESSION name:", name, " email:", email, " role:", role, " org:", organization, " loginStatus:", loginStatus)
      }
    }, 300);
  };

  useEffect(() => {
    // this reloadSession version does not revert to teh AutoLogin page
    
    reload();
  }, []); // eslint-disable-line

  // return (
  //   <div className={`min-h-screen bg-white font-sans transition-opacity duration-300 ${pageReady ? 'opacity-100' : 'opacity-0'}`} style={{ overflow: 'hidden' }}>
  //     <ToastContainer />
  //     <Router>
  //       <div className="flex flex-col h-screen">
  //         <Header />
  //         <div className="flex-grow overflow-auto">
  //           <Suspense fallback={<div className="text-3xl flex justify-center items-center h-full">Loading...</div>}>
  //             <Routes>
  //               <Route path="/login-entraid" element={<LoginEntraID />} />
  //               <Route path="/login" element={<Login />} />
  //               {loginStatus && role && <Route path="/" element={<Base />} />}
  //               {/* ... other routes ... */}
  //               <Route path="/register" element={<Register />} />
  //               <Route path="/register/complete" element={<Login />} />
  //               <Route path="/forgot/password" element={<ForgotPassword />} />
  //               <Route path="*" element={<Base />} />
  //             </Routes>
  //           </Suspense>
  //         </div>
  //         {false && currentPage !== 'login' && currentPage !== 'register' && <Footer />}
  //       </div>
  //     </Router>
  //   </div>
  // );

  return (
    <div className="min-h-screen bg-white font-sans" style={{ overflow: 'hidden' }}>
      <ToastContainer />
      <Router>
        <div className="flex flex-col h-screen">
          <Header />
          <div className="flex-grow overflow-auto">
            <Suspense
              fallback={
                <div
                  style={{
                    fontSize: '36px',
                    display: 'flex',
                    margin: 0,
                    width: '100vw',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  Loading...
                </div>
              }
            >
            <Routes>
            
                <Route path="/login-entraid" element={<LoginEntraID />} />
                <Route path="/login" element={<Login />} />

                {loginStatus && role &&
                  <Route path="/" element={<Base />} />}
                
                {loginStatus && role === 'admin' &&
                <Route path="/admin/dash" element={<AdminDash />} />}
                {loginStatus && (role === 'leader' || role === 'admin') &&
                <Route path="/leader/dash" element={<LeaderDash />} />}
                {loginStatus && (role === 'trainee' || role === 'admin') &&
                <Route path="/trainee/dash" element={<TraineeDash />} />}
                {/* One route for all three roles. The page picks the view, and the
                    server re-authorises every request from the verified token. */}
                {loginStatus && role &&
                <Route path="/metrics" element={<Metrics />} />}
                {/* Admin only. Anonymity is a commitment to the customer, set
                    per organisation per region by LavenirAI staff — not a
                    manager's own preference, which is what it used to be. */}
                {loginStatus && role === 'admin' &&
                <Route path="/metrics/settings" element={<MetricsSettings />} />}
                {/* Any role: who may use it is a server-side allowlist, which the
                    page asks for and every trial endpoint re-checks. */}
                {loginStatus && role &&
                <Route path="/trial-accounts" element={<TrialAccounts />} />}
                {loginStatus &&
                <Route path="/app" element={<UnityApp />} />}
                {loginStatus && role === 'admin' &&
                <Route path="/administrator" element={<Administrator />} />}
                {loginStatus && (role === 'admin' || role === 'leader') &&
                <Route path="/subscription" element={<Subscription />} />}
  
                {loginStatus && role === 'admin' &&
                <Route path="/logengine" element={<LogEngine />} />}

                <Route path="/register" element={<Register />} />
                <Route path="/register/complete" element={<Login />} />
                <Route path="/forgot/password" element={<ForgotPassword />} />
                <Route path="/subscribe" element={<Subscribe />} />
                <Route path="/subscribe-new" element={<SubscribeNew />} />
                
                <Route path="/subscription/new/success" element={<SubscriptionSuccess />} />
                <Route path="/subscription/update/success" element={<SubscriptionUpdateSuccess />} />
                <Route path="/subscription/renew/success" element={<SubscriptionRenewSuccess />} />
                <Route path="/subscription-error" element={<SubscriptionError />} />

                <Route 
                  path="/subscription/canceled" 
                  element={<Navigate to="/" replace />} 
                />

                <Route path="*" element={<Base />} />

              </Routes>
            </Suspense>
          </div>

          {false && currentPage !== 'login' && currentPage !== 'register' && (
            <Footer />
          )}

        </div>
      </Router>
    </div>
  );
}

function Header() {
  // visible on every page
  return (
    <div className="bg-[#FFFFFF]">
      <UserNav />
    </div>
  );
}
function Footer() {
  // const { app } = useSelector((state) => ({ ...state })); // eslint-disable-line
  // visible on every page
  return (
    <div className="app-footer">
      <p>
        LavenirAI -{' '}
        <a href="mailto:support@lavenirai.com">support@lavenirai.com</a>
      </p>
    </div>
  );
}

export default App;